import { render, staticRenderFns } from "./AdminDomainForm.vue?vue&type=template&id=7c414202&scoped=true"
import script from "./AdminDomainForm.vue?vue&type=script&lang=ts"
export * from "./AdminDomainForm.vue?vue&type=script&lang=ts"
import style0 from "./AdminDomainForm.vue?vue&type=style&index=0&id=7c414202&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_css-loader@6.11.0_webpack@5.106.2_postcss@8_65f48ef00f1eecf3a4c06689e8bb0300/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c414202",
  null
  
)

export default component.exports